import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import i18n from './lib/i18n/config';
import ScrollToTop from './components/utils/ScrollToTop';
import { LanguageProvider } from './lib/i18n/LanguageContext';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import SimonsMarketing from './pages/SimonsMarketing';
import FreeAnalysis from './pages/FreeAnalysis';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/de/imprint" element={<Imprint />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/de/privacy" element={<Privacy />} />
              <Route path="/free-analysis" element={<FreeAnalysis />} />
              <Route path="/de/free-analysis" element={<FreeAnalysis />} />
              <Route path="/" element={<SimonsMarketing />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </I18nextProvider>
  );
}

export default App;
